/*全体に必要なカスタムJavaScript  */
/*使用テンプレ：  footer.liquid*/

window.addEventListener('load', () => {

  /*レンズについてのモーダル */
          const lensBanner = document.getElementById('lens-banner');
          const lensModal = document.getElementById('lens-modal');
          
      if (lensBanner) {
          lensBanner.addEventListener('click', () => {
              lensModal.style.display = 'flex';
            　document.body.style.overflow = 'hidden';
          });
          
          lensModal.addEventListener('click', () => {
              lensModal.style.display = 'none';
            　document.body.style.overflow = 'auto'
          });
      }



});                        